

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


import isValid from '../../utils/validor'

import editIcon from 'assets/icons/icon_often_edit@3x.png'

import { mapActions, mapState, mapMutations } from 'vuex'

export default {
name: 'TourConfirm',
components: {
Group,
Cell,
XNumber,
XInput,
XButton,
XHeader,
},
data: () => ({
initTourOrderData: {
tourId: 0,
personCount: 1,
contactInfo: {
id: '',
name: null,
mobile: null,
},
},
editIcon,
}),
computed: {
...mapState({
tour: ({ routes }) => routes.tourDetail,
attn: ({ attn }) => attn.commonAttn,
tourOrderData: ({ order }) => order.tourOrderData,
}),
hasAttn() {
if (this.tourOrderData.contactInfo.id) {
return true
}
if (this.attn.id) {
this.tourOrderData.contactInfo = this.attn
return true
}
return false
},
totalPrice() {
return this.tour.price * this.tourOrderData.personCount
},
},
methods: {
...mapMutations({
saveTourOrderData: 'SAVE_TOUR_ORDER_DATA',
}),
...mapActions(['fetchUserCommonAttnByUserId', 'fetchOrder', 'fetchTourDetail', 'showToast']),
submitOrder() {
const self = this
const { tourId } = this.$route.params
const { userId } = this.$jwt
const { name, mobile } = this.tourOrderData.contactInfo

if (!name) {
this.showToast({
content: '请输入联系人姓名',
})
return false
}

if (isValid('number', name)) {
this.showToast({
content: '联系人填写有误，请检查！',
size: '15em',
})
return false
}

if (!mobile) {
this.showToast({
content: '请输入联系人手机号码',
size: '15em',
})
return false
}

if (!isValid('mobile', mobile)) {
this.showToast({
content: '手机号码填写有误，请输入11位国内手机号码！',
size: '21em',
})
return false
}

const req = {
personCount: self.tourOrderData.personCount,
contactInfo: {
name,
mobile,
},
packageTourRouteId: +tourId,
userId,
}

return this.$http.post('/api/tourOrder', req).then(res => res.json())
.then((order) => {
self.$router.push({
name: 'pay-order',
query: {
orderId: order.id,
type: 'tour',
},
})
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
mutateOrder() {
const { tourId } = this.$route.params
this.tourOrderData.tourId = tourId
this.saveTourOrderData(this.tourOrderData)
},
goToAttn(type, attnId) {
const query = { from: 'tourOrder' }
if (attnId) {
query.id = attnId
} else {
query.type = 'attn'
}
this.mutateOrder()
this.$router.push({
name: `attn-${type}`,
query,
})
},
},
created() {
document.title = '确认预订'
const { tourId } = this.$route.params
const { userId } = this.$jwt
this.fetchUserCommonAttnByUserId(userId)
if (+tourId !== +this.tourOrderData.tourId) {
this.saveTourOrderData(this.initTourOrderData)
}
this.fetchTourDetail({
id: tourId,
userId,
}).catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
setTimeout(() => {
window.history.back()
}, 1000)
})
},
}



// WEBPACK FOOTER //
// ./client/components/WorldCup/TourConfirm.vue